enum IconName {
    // Hero icons
    ACADEMIC_CAP = 'academic-cap',
    ADJUSTMENTS = 'adjustments',
    ANNOTATION = 'annotation',
    ARCHIVE = 'archive',
    ARROW_CIRCLE_DOWN = 'arrow-circle-down',
    ARROW_CIRCLE_LEFT = 'arrow-circle-left',
    ARROW_CIRCLE_RIGHT = 'arrow-circle-right',
    ARROW_CIRCLE_UP = 'arrow-circle-up',
    ARROW_DOWN = 'arrow-down',
    ARROW_LEFT = 'arrow-left',
    ARROW_NARROW_DOWN = 'arrow-narrow-down',
    ARROW_NARROW_LEFT = 'arrow-narrow-left',
    ARROW_NARROW_RIGHT = 'arrow-narrow-right',
    ARROW_NARROW_UP = 'arrow-narrow-up',
    ARROW_RIGHT = 'arrow-right',
    ARROW_SM_DOWN = 'arrow-sm-down',
    ARROW_SM_LEFT = 'arrow-sm-left',
    ARROW_SM_RIGHT = 'arrow-sm-right',
    ARROW_SM_UP = 'arrow-sm-up',
    ARROW_UP = 'arrow-up',
    ARROWS_EXPAND = 'arrows-expand',
    AT_SYMBOL = 'at-symbol',
    BACKSPACE = 'backspace',
    BADGE_CHECK = 'badge-check',
    BAN = 'ban',
    BEAKER = 'beaker',
    BELL = 'bell',
    BOOK_OPEN = 'book-open',
    BOOKMARK = 'bookmark',
    BOOKMARK_ALT = 'bookmark-alt',
    BRIEFCASE = 'briefcase',
    CAKE = 'cake',
    CALCULATOR = 'calculator',
    CALENDAR = 'calendar',
    CAMERA = 'camera',
    CASH = 'cash',
    CHART_BAR = 'chart-bar',
    CHART_PIE = 'chart-pie',
    CHART_SQUARE_BAR = 'chart-square-bar',
    CHAT = 'chat',
    CHAT_ALT = 'chat-alt',
    CHAT_ALT_2 = 'chat-alt-2',
    CHECK = 'check',
    CHECK_CIRCLE = 'check-circle',
    CHEVRON_DOUBLE_DOWN = 'chevron-double-down',
    CHEVRON_DOUBLE_LEFT = 'chevron-double-left',
    CHEVRON_DOUBLE_RIGHT = 'chevron-double-right',
    CHEVRON_DOUBLE_UP = 'chevron-double-up',
    CHEVRON_DOWN = 'chevron-down',
    CHEVRON_LEFT = 'chevron-left',
    CHEVRON_RIGHT = 'chevron-right',
    CHEVRON_UP = 'chevron-up',
    CHIP = 'chip',
    CLIPBOARD = 'clipboard',
    CLIPBOARD_CHECK = 'clipboard-check',
    CLIPBOARD_COPY = 'clipboard-copy',
    CLIPBOARD_LIST = 'clipboard-list',
    CLOCK = 'clock',
    CLOUD = 'cloud',
    CLOUD_DOWNLOAD = 'cloud-download',
    CLOUD_UPLOAD = 'cloud-upload',
    CODE = 'code',
    COG = 'cog',
    COLLECTION = 'collection',
    COLOR_SWATCH = 'color-swatch',
    CREDIT_CARD = 'credit-card',
    CUBE = 'cube',
    CUBE_TRANSPARENT = 'cube-transparent',
    CURRENCY_BANGLADESHI = 'currency-bangladeshi',
    CURRENCY_DOLLAR = 'currency-dollar',
    CURRENCY_EURO = 'currency-euro',
    CURRENCY_POUND = 'currency-pound',
    CURRENCY_RUPEE = 'currency-rupee',
    CURRENCY_YEN = 'currency-yen',
    CURSOR_CLICK = 'cursor-click',
    DATABASE = 'database',
    DESKTOP_COMPUTER = 'desktop-computer',
    DEVICE_MOBILE = 'device-mobile',
    DEVICE_TABLET = 'device-tablet',
    DOCUMENT = 'document',
    DOCUMENT_ADD = 'document-add',
    DOCUMENT_DOWNLOAD = 'document-download',
    DOCUMENT_DUPLICATE = 'document-duplicate',
    DOCUMENT_REMOVE = 'document-remove',
    DOCUMENT_REPORT = 'document-report',
    DOCUMENT_SEARCH = 'document-search',
    DOCUMENT_TEXT = 'document-text',
    DOTS_CIRCLE_HORIZONTAL = 'dots-circle-horizontal',
    DOTS_HORIZONTAL = 'dots-horizontal',
    DOTS_VERTICAL = 'dots-vertical',
    DOWNLOAD = 'download',
    DUPLICATE = 'duplicate',
    EMOJI_HAPPY = 'emoji-happy',
    EMOJI_SAD = 'emoji-sad',
    EXCLAMATION = 'exclamation',
    EXCLAMATION_CIRCLE = 'exclamation-circle',
    EXTERNAL_LINK = 'external-link',
    EYE = 'eye',
    EYE_OFF = 'eye-off',
    FAST_FORWARD = 'fast-forward',
    FILM = 'film',
    FILTER = 'filter',
    FINGER_PRINT = 'finger-print',
    FIRE = 'fire',
    FLAG = 'flag',
    FOLDER = 'folder',
    FOLDER_ADD = 'folder-add',
    FOLDER_DOWNLOAD = 'folder-download',
    FOLDER_OPEN = 'folder-open',
    FOLDER_REMOVE = 'folder-remove',
    GIFT = 'gift',
    GLOBE = 'globe',
    GLOBE_ALT = 'globe-alt',
    HAND = 'hand',
    HASHTAG = 'hashtag',
    HEART = 'heart',
    HOME = 'home',
    IDENTIFICATION = 'identification',
    INBOX = 'inbox',
    INBOX_IN = 'inbox-in',
    INFORMATION_CIRCLE = 'information-circle',
    KEY = 'key',
    LIBRARY = 'library',
    LIGHT_BULB = 'light-bulb',
    LIGHTNING_BOLT = 'lightning-bolt',
    LINK = 'link',
    LOCATION_MARKER = 'location-marker',
    LOCK_CLOSED = 'lock-closed',
    LOCK_OPEN = 'lock-open',
    LOGIN = 'login',
    LOGOUT = 'logout',
    MAIL = 'mail',
    MAIL_OPEN = 'mail-open',
    MAP = 'map',
    MENU = 'menu',
    MENU_ALT_1 = 'menu-alt-1',
    MENU_ALT_2 = 'menu-alt-2',
    MENU_ALT_3 = 'menu-alt-3',
    MENU_ALT_4 = 'menu-alt-4',
    MICROPHONE = 'microphone',
    MINUS = 'minus',
    MINUS_CIRCLE = 'minus-circle',
    MINUS_SM = 'minus-sm',
    MOON = 'moon',
    MUSIC_NOTE = 'music-note',
    NEWSPAPER = 'newspaper',
    OFFICE_BUILDING = 'office-building',
    PAPER_AIRPLANE = 'paper-airplane',
    PAPER_CLIP = 'paper-clip',
    PAUSE = 'pause',
    PENCIL = 'pencil',
    PENCIL_ALT = 'pencil-alt',
    PHONE = 'phone',
    PHONE_INCOMING = 'phone-incoming',
    PHONE_MISSED_CALL = 'phone-missed-call',
    PHONE_OUTGOING = 'phone-outgoing',
    PHOTOGRAPH = 'photograph',
    PLAY = 'play',
    PLUS = 'plus',
    PLUS_CIRCLE = 'plus-circle',
    PLUS_SM = 'plus-sm',
    PRESENTATION_CHART_BAR = 'presentation-chart-bar',
    PRESENTATION_CHART_LINE = 'presentation-chart-line',
    PRINTER = 'printer',
    PUZZLE = 'puzzle',
    QR_CODE = 'qr-code',
    QUESTION_MARK_CIRCLE = 'question-mark-circle',
    RECEIPT_REFUND = 'receipt-refund',
    RECEIPT_TAX = 'receipt-tax',
    REFRESH = 'refresh',
    REPLY = 'reply',
    REWIND = 'rewind',
    RSS = 'rss',
    SAVE = 'save',
    SAVE_AS = 'save-as',
    SCALE = 'scale',
    SCISSORS = 'scissors',
    SEARCH = 'search',
    SEARCH_CIRCLE = 'search-circle',
    SELECTOR = 'selector',
    SERVER = 'server',
    SHARE = 'share',
    SHIELD_CHECK = 'shield-check',
    SHIELD_EXCLAMATION = 'shield-exclamation',
    SHOPPING_BAG = 'shopping-bag',
    SHOPPING_CART = 'shopping-cart',
    SORT_ASCENDING = 'sort-ascending',
    SORT_DESCENDING = 'sort-descending',
    SPARKLES = 'sparkles',
    SPEAKERPHONE = 'speakerphone',
    STAR = 'star',
    STATUS_OFFLINE = 'status-offline',
    STATUS_ONLINE = 'status-online',
    STOP = 'stop',
    SUN = 'sun',
    SUPPORT = 'support',
    SWITCH_HORIZONTAL = 'switch-horizontal',
    SWITCH_VERTICAL = 'switch-vertical',
    TABLE = 'table',
    TAG = 'tag',
    TEMPLATE = 'template',
    TERMINAL = 'terminal',
    THUMB_DOWN = 'thumb-down',
    THUMB_UP = 'thumb-up',
    TICKET = 'ticket',
    TRANSLATE = 'translate',
    TRASH = 'trash',
    TRENDING_DOWN = 'trending-down',
    TRENDING_UP = 'trending-up',
    TRUCK = 'truck',
    UPLOAD = 'upload',
    USER = 'user',
    USER_ADD = 'user-add',
    USER_CIRCLE = 'user-circle',
    USER_GROUP = 'user-group',
    USER_REMOVE = 'user-remove',
    USERS = 'users',
    VARIABLE = 'variable',
    VIDEO_CAMERA = 'video-camera',
    VIEW_BOARDS = 'view-boards',
    VIEW_GRID = 'view-grid',
    VIEW_GRID_ADD = 'view-grid-add',
    VIEW_LIST = 'view-list',
    VOLUME_OFF = 'volume-off',
    VOLUME_UP = 'volume-up',
    WIFI = 'wifi',
    X = 'x',
    X_CIRCLE = 'x-circle',
    ZOOM_IN = 'zoom-in',
    ZOOM_OUT = 'zoom-out',

    // Extensions - ngage
    CHEVRON_UP_DOWN = 'chevron-up-down',

    // Extensions - custom
    AFRICAN_MEDIA_ONLINE = 'african-media-online',
    ANTIQUE_CAR = 'antique-car',
    ATHLETICS = 'athletics',
    AVATAR = 'avatar',
    AVIAN = 'avian',
    BABY_BOTTLE = 'baby-bottle',
    BABY_CHANGING = 'baby-changing',
    BATH = 'bath',
    BEACON = 'beacon',
    BED = 'bed',
    BEDROOM = 'bedroom',
    BIRD = 'bird',
    CAROUSEL = 'carousel',
    CAUTION_RAILWAY = 'caution-railway',
    COACH = 'coach',
    COAL_WAGON = 'coal-wagon',
    COCKTAIL_GLASS = 'cocktail-glass',
    COFFEE_CUP = 'coffee-cup',
    CRICKET = 'cricket',
    CUTLERY = 'cutlery',
    DEFIBRILLATOR = 'defibrillator',
    DISABLED_HOIST = 'disabled-hoist',
    DISABLED = 'disabled',
    DO_NOT_TOUCH = 'do-not-touch',
    DOG = 'dog',
    DUCK_FOOTPRINT = 'duck-footprint',
    ELEVATOR = 'elevator',
    EMERGENCY_EXIT = 'emergency-exit',
    FIRST_AID = 'first-aid',
    FISH = 'fish',
    FLOWER = 'flower',
    FOOTBALL = 'football',
    FROG = 'frog',
    GOLF = 'golf',
    HAND_WASH = 'hand-wash',
    HERITAGE_SHIP = 'heritage-ship',
    HOT = 'hot',
    HOURGLASS = 'hourglass',
    HOUSE = 'house',
    IBCCES= 'ibcces',
    ICE_CREAM = 'ice-cream',
    INFORMATION = 'information',
    INSECT = 'insect',
    KULTURE_CITY = 'kulture-city',
    MONKEY_FOOTPRINT = 'monkey-footprint',
    MOTHER_CHILD = 'mother-child',
    MUSIC = 'music',
    PADLOCK = 'padlock',
    PARKING = 'parking',
    PAW_PRINT = 'paw-print',
    PERSON_SPEAKING = 'person-speaking',
    PICNIC_TABLE = 'picnic-table',
    PLAYGROUND = 'playground',
    POINT_OF_INTEREST = 'point-of-interest',
    PRAIRIE_WAGON = 'prairie-wagon',
    PUSHCHAIR = 'pushchair',
    QUESTION_MARK = 'question-mark',
    REPTILE = 'reptile',
    RUGBY = 'rugby',
    SAXOPHONE = 'saxophone',
    SMOKING = 'smoking',
    SPORT = 'sport',
    STAY_LOCAL_PARTNER = 'stay-local-partner',
    STEAM_TRAIN = 'steam-train',
    STREETCAR = 'streetcar',
    TENT = 'tent',
    TOILETS = 'toilets',
    TRACTOR = 'tractor',
    TREE = 'tree',
    WALK_OF_FAME = 'walk-of-fame',
    WATER = 'water',
    WHEELCHAIR = 'wheelchair',
    WHEELCHAIR_LIFT = 'wheelchair-lift',
    WHEELCHAIR_RAMP = 'wheelchair-ramp',

    // Extensions - social
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    LINKED_IN = 'linked-in',
    YOU_TUBE = 'you-tube',
    TIK_TOK = 'tik-tok',
    TWITTER = 'twitter',
    VIMEO = 'vimeo',
}

export default IconName